<template>
  <div>
    <component :is="layoutComponent" />
  </div>
  <UpdateRequiredModal v-model="showModal" />
</template>

<script setup>
import { ref, computed, onMounted, onUnmounted } from 'vue';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';
import axios from 'axios';

import MainLayout from './core/layout/MainLayout.vue';
import EmptyLayout from './core/layout/EmptyLayout.vue';
import UpdateRequiredModal from './core/main/UpdateRequiredModal.vue';

import { loadStimulsoftLicense } from './core/store';

const showModal = ref(false);

let versionCheckInterval = null;

const route = useRoute();
const store = useStore();

const isLocalEnvironment = (url) => {
  const localPatterns = ['192.168', '10.', '127.', 'localhost'];
  return localPatterns.some((pattern) => url.includes(pattern));
};

const getVersion = async () => {
  try {
    const response = await axios.get('/version.json');
    const json = response.data;
    console.log('/version.json', json, sessionStorage.version);

    if (json.version) {
      const savedVersion = sessionStorage.getItem('version');
      if (savedVersion && String(savedVersion) !== String(json.version)) {
        console.warn(
          `Требуется обновить страницу ${savedVersion} -> ${json.version}`
        );
        showModal.value = true;
      }
      sessionStorage.setItem('version', json.version);
    }
  } catch (error) {
    console.error('Ошибка загрузки version.json:', error);
  }
};

const layoutComponent = computed(() => {
  const layoutName = route.meta.layout || 'empty';
  return layoutName === 'main' ? MainLayout : EmptyLayout;
});

onMounted(() => {
  const { protocol, hostname, href } = window.location;

  store.dispatch('setProtocol', protocol);
  store.dispatch('setHostname', hostname);

  const direction = isLocalEnvironment(href) ? 'LOCAL' : 'EXTERNAL';
  store.dispatch('setDirection', direction);

  getVersion();
  versionCheckInterval = setInterval(() => getVersion(), 600000);

  // Load Stimulsoft license after Stimulsoft is available
  loadStimulsoftLicense();
});

onUnmounted(() => {
  if (versionCheckInterval) {
    clearInterval(versionCheckInterval);
  }
});
</script>

<style lang="scss">
@use 'core/assets/App.scss' as *;
@use 'core/assets/index.css' as *;
</style>